import { FormControl, type FormControlProps } from '@chakra-ui/react';

export type UiFormControlProps = FormControlProps;

export const UiFormControl = FormControl;
